// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__sRhNT","rotate":"styles_rotate__hROJe","path":"styles_path__9ft5g","dash":"styles_dash__nXeKy"};